import { flatten } from 'lodash'
import moment from 'moment'
import PresentationApi from '@/api/presentation'
import util from '@/util'
import store from '@/vuex/store'
import CommunityApi from '@/api/community'

const GET_TEMPLATES_ADMIN_PICKED_START = 'GET_TEMPLATES_ADMIN_PICKED_START'
const GET_TEMPLATES_ADMIN_PICKED_SUCCEEDED = 'GET_TEMPLATES_ADMIN_PICKED_SUCCEEDED'
const GET_TEMPLATES_ADMIN_PICKED_FAILED = 'GET_TEMPLATES_ADMIN_PICKED_FAILED'

const GET_TEMPLATES_START = 'GET_TEMPLATES_START'
const GET_TEMPLATES_SUCCEEDED = 'GET_TEMPLATES_SUCCEEDED'
const GET_TEMPLATES_FAILED = 'GET_TEMPLATES_FAILED'

const GET_NEWLY_ADDED_START = 'GET_NEWLY_ADDED_START'
const GET_NEWLY_ADDED_SUCCEEDED = 'GET_NEWLY_ADDED_SUCCEEDED'
const GET_NEWLY_ADDED_FAILED = 'GET_NEWLY_ADDED_FAILED'
const UPDATE_NEWLY_ADDED_AFTER_PUBLISH = 'UPDATE_NEWLY_ADDED_AFTER_PUBLISH'

const COPY_TEMPLATE_START = 'COPY_TEMPLATE_START'
const COPY_TEMPLATE_SUCCEEDED = 'COPY_TEMPLATE_SUCCEEDED'
const COPY_TEMPLATE_FAILED = 'COPY_TEMPLATE_FAILED'

const _state = {
  templateCategories: null,
  templateAdminPicked: null,
  templateAdminPickedForMobileFull: null,
  templateAdminPickedForMobileMini: null,
  isLoadingTemplates: true,
  getTemplatesError: null,
  newlyAddedCommunityTemplates: null,
  newlyAddedCommunityTemplatesForMobileMini: null,
  newlyAddedCommunityTemplatesForMobileFull: null,
  isLoadingNewlyAdded: true,
  isLoadingTemplateAdminPicked: true,
  getNewlyAddedError: null,
  getTemplateAdminPickedError: null,
  copyingTemplateId: null,
  copyError: false,
}

const sortByUpdatedDate = (a, b) => {
  return new Date(b.updatedAt) - new Date(a.updatedAt)
}

const sortByDownload = (a, b) => {
  return b.copyCount - a.copyCount
}

const sortByTag = (a, b, tag) => {
  return b.tags.includes(tag) - a.tags.includes(tag)
}

const sortByPin = (a, b) => {
  return b.tags.includes('pin') - a.tags.includes('pin')
}

const removeLowQualityPresentation = (list) => {
  const blackList = [
    'My new presentation',
    'Your saved Spinner Wheel',
    'Your saved WordCloud',
  ]
  const whiteList = [
    'General Knowledge Quiz',
  ]
  return list.filter((item) => {
    if (whiteList.includes(item.name)) {
      return true
    }
    if (parseInt(item.slideCount, 10) < 3) {
      return false
    }
    if (blackList.includes(item.name)) {
      return false
    }
    if (item.User.type === 'official') {
      return false
    }
    return true
  })
}

const getters = {
  templateCategories(state) {
    return state.templateCategories
  },
  templateAdminPicked(state) {
    return state.templateAdminPicked
  },
  templateAdminPickedForMobileFull(state) {
    return state.templateAdminPickedForMobileFull
  },
  templateAdminPickedForMobileMini(state) {
    return state.templateAdminPickedForMobileMini
  },
  isLoadingTemplates(state) {
    return state.isLoadingTemplates
  },
  templatesError(state) {
    return state.getTemplatesError
  },
  newlyAddedCommunityTemplates(state) {
    return state.newlyAddedCommunityTemplates
  },
  newlyAddedCommunityTemplatesForMobileMini(state) {
    return state.newlyAddedCommunityTemplatesForMobileMini
  },
  newlyAddedCommunityTemplatesForMobileFull(state) {
    return state.newlyAddedCommunityTemplatesForMobileFull
  },
  isLoadingNewlyAdded(state) {
    return state.isLoadingNewlyAdded
  },
  isLoadingTemplateAdminPicked(state) {
    return state.isLoadingTemplateAdminPicked
  },
  getNewlyAddedError(state) {
    return state.getgetNewlyAddedError
  },
  getTemplateAdminPickedError(state) {
    return state.getTemplateAdminPickedError
  },
  copyingTemplateId(state) {
    return state.copyingTemplateId
  },
  trendingTemplates(state) {
    let templates = flatten(state.templateCategories.map((category) => {
      if (!category.presentations) return []
      return category.presentations
        .sort(sortByUpdatedDate)
        .slice(0, 3)
    }))

    templates.sort(sortByUpdatedDate)

    templates = templates.map((item) => {
      if (!item.tags) item.tags = []
      return item
    })
    if (store.state.currentUser) {
      const { personalInformation } = store.state.currentUser
      if (personalInformation && personalInformation.useAhaSlidesFor) {
        templates = templates.sort((a, b) => {
          return sortByTag(a, b, personalInformation.useAhaSlidesFor)
        })
      }
    }
    return templates
  },
  topTemplates(state) {
    let templates = flatten(state.templateCategories.map((category) => {
      if (!category.presentations) return []
      return category.presentations
    }))
    templates = templates.sort(sortByUpdatedDate)
    templates = templates.map((item) => {
      if (!item.tags) item.tags = []
      return item
    })
    if (store.state.currentUser) {
      const { personalInformation } = store.state.currentUser
      if (personalInformation && personalInformation.useAhaSlidesFor) {
        templates = templates.sort((a, b) => {
          return sortByTag(a, b, personalInformation.useAhaSlidesFor)
        })
      }
    }
    templates = templates.sort(sortByPin)
    return templates
  },

}

const actions = {
  getTemplatesAdminPickedAction: async ({ commit }) => {
    commit(GET_TEMPLATES_ADMIN_PICKED_START)
    try {
      const response = await PresentationApi.getTemplatesAdminPicked()

      const shuffledTemplates = response.templates.sort(() => 0.5 - Math.random())

      commit(GET_TEMPLATES_ADMIN_PICKED_SUCCEEDED, shuffledTemplates)
      return true
    } catch (error) {
      commit(GET_TEMPLATES_ADMIN_PICKED_FAILED, error)
      return false
    }
  },
  getTemplatesOldAction: async ({ commit }) => {
    commit(GET_TEMPLATES_START)
    try {
      const response = await PresentationApi.getTemplates()
      response.folders = response.folders.map((f) => {
        f.presentations = f.presentations.sort(sortByDownload)
        return f
      })
      commit(GET_TEMPLATES_SUCCEEDED, response.folders)
      return true
    } catch (error) {
      commit(GET_TEMPLATES_FAILED, error)
      return false
    }
  },
  getTemplatesAction: async ({ commit }) => {
    commit(GET_TEMPLATES_START)
    try {
      const presentationNewlyAdded = await CommunityApi.getNewlyAddedPublicPresentations()
      const qualityPresentationsNewlyAdded = removeLowQualityPresentation(presentationNewlyAdded)
      const response = await PresentationApi.getTemplates()
      const folderNewlyAdded = {
        folderName: 'By community',
        folderId: 999999999,
        presentations: qualityPresentationsNewlyAdded,
      }
      response.folders.push(folderNewlyAdded)
      response.folders = response.folders.map((f) => {
        f.presentations = f.presentations.sort(sortByDownload).slice(0, 12)
        return f
      })
      commit(GET_TEMPLATES_SUCCEEDED, response.folders)
      return true
    } catch (error) {
      commit(GET_TEMPLATES_FAILED, error)
      return false
    }
  },
  getNewlyAddedOldAction: async ({ commit }) => {
    commit(GET_NEWLY_ADDED_START)
    try {
      const presentations = await CommunityApi.getNewlyAddedPublicPresentations()
      const qualityPresentations = removeLowQualityPresentation(presentations)
      commit(GET_NEWLY_ADDED_SUCCEEDED, qualityPresentations)
      return true
    } catch (error) {
      commit(GET_NEWLY_ADDED_FAILED, error)
      return false
    }
  },
  getNewlyAddedAction: async ({ commit }) => {
    commit(GET_NEWLY_ADDED_START)
    try {
      const qualityPresentations = []
      const response = await PresentationApi.getTemplates()
      response.folders.forEach((item) => {
        item.presentations.forEach((presentation) => {
          qualityPresentations.push(presentation)
        })
      })

      const shuffledTemplates = qualityPresentations.sort((a, b) => {
        return moment(b.createdAt).diff(moment(a.createdAt))
      })

      commit(GET_NEWLY_ADDED_SUCCEEDED, shuffledTemplates)
      return true
    } catch (error) {
      commit(GET_NEWLY_ADDED_FAILED, error)
      return false
    }
  },
  updateNewlyAddedAfterPublishAction: ({ commit }, payload) => {
    commit(UPDATE_NEWLY_ADDED_AFTER_PUBLISH, payload)
  },
  copyFromTemplateAction: async ({ commit, state }, { template, callback, isTracking = true }) => {
    if (state.copyingTemplateId) return
    commit(COPY_TEMPLATE_START, template.id)
    try {
      const copiedPresentation = await PresentationApi.copyTemplateToAccount({
        id: template.id,
      })
      if (isTracking) {
        util.gaTrackEvent('Presentation List', 'Create new presentation', 'Use template', null, {
          sourcePresentationId: template.id,
          presentationId: copiedPresentation.id,
        })
      }
      commit(COPY_TEMPLATE_SUCCEEDED)
      callback(copiedPresentation)
    } catch (error) {
      commit(COPY_TEMPLATE_FAILED, error)
    }
  },

}

const mutations = {
  [GET_TEMPLATES_START](state) {
    state.isLoadingTemplates = true
  },
  [GET_TEMPLATES_SUCCEEDED](state, templateCategories) {
    state.templateCategories = templateCategories
    state.isLoadingTemplates = false
  },
  [GET_TEMPLATES_FAILED](state, error) {
    state.getTemplatesError = error
    state.isLoadingTemplates = false
  },

  [GET_NEWLY_ADDED_START](state) {
    state.isLoadingNewlyAdded = true
  },
  [GET_TEMPLATES_ADMIN_PICKED_START](state) {
    state.isLoadingTemplateAdminPicked = true
  },
  [GET_TEMPLATES_ADMIN_PICKED_FAILED](state, error) {
    state.getTemplateAdminPickedError = error
    state.isLoadingTemplateAdminPicked = false
  },
  [GET_TEMPLATES_ADMIN_PICKED_SUCCEEDED](state, templateCategories) {
    state.templateAdminPicked = JSON.parse(JSON.stringify(templateCategories))
    const mobileFull = templateCategories.splice(0, 10)
    state.templateAdminPickedForMobileMini = mobileFull.splice(0, 3)
    state.templateAdminPickedForMobileFull = mobileFull
    state.isLoadingTemplateAdminPicked = false
  },
  [UPDATE_NEWLY_ADDED_AFTER_PUBLISH](state, newly) {
    const latestList = state.newlyAddedCommunityTemplates.map((item) => {
      if (item.id === newly.id) {
        if (newly.customThumbnailImage) {
          item.customThumbnailImage = newly.customThumbnailImage
        }
        item.description = newly.description
        item.name = newly.name
      }
      return item
    })
    state.newlyAddedCommunityTemplates = latestList
  },
  [GET_NEWLY_ADDED_SUCCEEDED](state, newlyAddedCommunityTemplates) {
    state.newlyAddedCommunityTemplates = JSON.parse(JSON.stringify(newlyAddedCommunityTemplates))
    const mobileFull = newlyAddedCommunityTemplates.splice(0, 10)
    state.newlyAddedCommunityTemplatesForMobileMini = mobileFull.splice(0, 3)
    state.newlyAddedCommunityTemplatesForMobileFull = mobileFull
    state.isLoadingNewlyAdded = false
  },
  [GET_NEWLY_ADDED_FAILED](state, error) {
    state.getNewlyAddedError = error
    state.isLoadingNewlyAdded = false
  },

  [COPY_TEMPLATE_START](state, templateId) {
    state.copyingTemplateId = templateId
  },

  [COPY_TEMPLATE_SUCCEEDED](state) {
    state.copyingTemplateId = null
  },

  [COPY_TEMPLATE_FAILED](state, error) {
    state.copyError = error
    state.copyingTemplateId = null
  },

}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
